import { Component } from '@angular/core';

@Component({
    selector: 'app-weighing-admin',
    templateUrl: './weighing-admin.component.html',
    styleUrls: ['./weighing-admin.component.scss'],
    standalone: false
})
export class WeighingAdminComponent {

}
